export default "__VITE_ASSET__BM7VE1Zf__"